import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useProfile } from "Common/Hooks/UserHooks";
import { logoutUser } from "slices/thunk";

const AuthProtected = (props: any) => {
  const dispatch = useDispatch<any>();
  const { userProfile } = useProfile();

  useEffect(() => {
    if (userProfile) {
    } else if (!userProfile) {
      dispatch(logoutUser());
    }
  }, [userProfile, dispatch]);

  if (!userProfile) {
    return (
      <Navigate to={{ pathname: "/login" }} />
    );
  }
  return <>{props.children}</>;
};

export { AuthProtected };